import { createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "px-5 py-3 text-center" }
const _hoisted_2 = ["id"]
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<path transform=\"translate(632,869)\" d=\"m0 0 4 1v10l-4 45-1 14v55l1 49v75l-1 34-3 42-2 19-7 43-3 25-6 40-2 20-6 50-2 31-4-5-12-20-3-6-10-19-5-10-7-15-9-23-5-22-3-20-3-54v-34l3-47 4-23 6-25 6-16 4-13 4-11 4-13 5-13 4-13 8-24 13-38 5-15 13-38 7-20 3-10z\" fill=\"#BABABB\"></path><path transform=\"translate(346,869)\" d=\"m0 0h4l4 7 7 24 6 20 4 11 4 13 5 15 6 17 5 15 9 25 5 13 6 17 7 20 5 14 8 24 7 33 2 14 1 16 1 14v63l-2 26-1 16-4 24-7 24-5 11-4 10-7 15-12 22-9 16-8 13h-1l-4-45-6-47-2-19-7-47-1-11-8-49-3-44-1-24v-115l1-39v-35l-3-40-2-21z\" fill=\"#BABABB\"></path><path transform=\"translate(574,1396)\" d=\"m0 0 4 5 9 16 7 14 7 16 4 13 4 12 7 33 2 17 1 35-1 30-4 26-8 35-5 19-10 34-11 33-4 10-5 13-9 21-12 22-9 11-22 22-7 8-11 12h-2l1-13 3-10 2-12 6-18 6-15 3-10 1-19-2-31-3-26-1-13-8-53-1-11-5-38v-17l3-15 8-26 8-32 3-7 2 3 1 11 7 47 3 26 6 39 2 30v44l-2 29-1 16-4 23-5 22-7 20-6 15-5 15 10-21 4-12 4-10 8-28 8-44 6-55 3-28 3-23 6-36 2-16 6-35 1-8 1-24v-36l-1-31-1-10z\" fill=\"#BABABB\"></path><path transform=\"translate(407,1396)\" d=\"m0 0h1v10l-2 22v78l4 27 4 23 2 16 6 36 3 24 6 56 2 20 8 45 10 35 6 16 9 20 1 4v-3l-4-12-7-17-3-10-5-14-5-25-4-28-1-25v-58l2-26 7-45 2-19 7-48 1-10 2-1 6 20 2 10 6 20 6 21 2 14-1 18-6 43-1 12-7 46-5 54v24l2 12 5 13 6 15 7 24 2 14v6l-4-1-9-10-7-8-7-7-7-8-8-7-8-10-9-16-8-16-10-24-7-20-9-27-9-30-4-16-5-19-4-20-4-23-1-10v-44l2-27 5-26 6-23 7-19 7-17 10-18zm55 134-4 5-3\" fill=\"#BABABB\"></path><path transform=\"translate(633,321)\" d=\"m0 0 6 2 11 1v2l-15 8-9 7-6 10v8l10 24 11 24 10 18 6 10 4 7 5 14v9l-7 8-16 13-8 6-13 8-15 8-10 4-18 3h-28l-16-4-11-7-9-8-8-11-7-14-3-17v-20l2-39 5-13 6-8 9-8 16-8 17-6 25-8 12-4 12-3 10-4 15-9z\" fill=\"#BABABB\"></path><path transform=\"translate(346,321)\" d=\"m0 0 5 1 12 6 9 6 15 5 18 5 33 11 15 6 13 7 7 7 6 9 3 9 2 23 1 34-3 21-6 12-7 10-11 11-14 8-14 3h-27l-19-3-21-10-18-11v-2l-4-2-11-8-10-9-4-4v-11l6-15 9-16 6-11 8-15 9-20 5-13 3-7-1-8-4-7-10-9-14-8 3-2 9-2z\" fill=\"#BABABB\"></path><path transform=\"translate(621,869)\" d=\"m0 0h1l-1 9-4 17-6 18-4 13-6 17-7 16-3 8-12 29-7 19-5 13-7 18-6 17-5 15-7 18-3 10-12 35-2 6-3 10-5 14-2 9-7 22-1 3h-1l-2-17-4-57-1-16-3-92v-26l1-10 5-5 8-6 6-4 4-4 17-12 16-13 10-9 13-12 18-18 9-11 7-8 10-15z\" fill=\"#BABABB\"></path><path transform=\"translate(360,869)\" d=\"m0 0 3 3 11 16 1 3 4 2 2 5 3 1 7 8 11 12 15 14 6 5v2l4 2 15 12 19 14 12 9 9 7 3 5v56l-2 45-1 35-4 58-2 21-2 1-4-15-5-15-5-17-12-35-4-13-10-29-3-7-3-10-6-15-4-12-10-26-3-7-3-9-11-27-4-10-7-17-9-25-5-17-4-15-2-9z\" fill=\"#BABABB\"></path><path transform=\"translate(699,465)\" d=\"m0 0 9 1 13 5 10 6 7 4v2l4 2 8 7 7 8 6 9 7 17 5 25 3 31 2 38v50l-2 33-1 8h-2l-5-12-15-23-8-12-7-10-8-16-6-15-5-12-3-10-6-16-2-9-6-19-8-36-5-35v-13l3-6z\" fill=\"#BABABB\"></path><path transform=\"translate(277,465)\" d=\"m0 0 9 1 4 5 1 3v10l-6 41-7 29-4 16-8 25-11 30-6 15-9 17-4 5-20 30-8 16-3 3-2-18-1-17v-63l2-31 2-26 5-27 8-20 7-11 8-9 10-8 13-8 10-5z\" fill=\"#BABABB\"></path><path transform=\"translate(654,328)\" d=\"m0 0 10 3 13 5 23 12 10 7 13 11 8 7v2l4 2 7 11 7 16 5 16 6 34 2 24v7l-4-1-8-7-9-6-27-11-23-11-14-9-13-10-9-10-7-11-4-6-9-19-3-9-5-17v-10l5-7 13-9z\" fill=\"#BABABB\"></path><path transform=\"translate(553,762)\" d=\"m0 0h14l5 3 2 4v13l-3 27-3 17-2 14-6 23-3 12-8 23-10 21-9 14-12 13h-2v2l-12 5-8 3h-3l-1-43v-59l2-35 3-25 2-12 4-4 8-4 11-4 25-7z\" fill=\"#BABABB\"></path><path transform=\"translate(415,762)\" d=\"m0 0h14l20 5 16 5 12 5 5 4 3 14 3 28 1 14v119l-6-1-15-6-11-9-2-5-3-1-10-17-7-14-5-13-8-23-2-10-6-25-3-22-3-23v-19l5-5z\" fill=\"#BABABB\"></path><path transform=\"translate(326,328)\" d=\"m0 0 9 3 12 8 7 7v16l-8 22-3 7-8 17h-2l-2 5-8 11-11 11-15 10-12 7-17 8-18 7-16 8-11 10h-3v-11l1-5 2-23 5-24 4-15 7-17 4-6 8-7 21-21 19-12 6-4 7-3 11-5 8-2z\" fill=\"#BABABB\"></path><path transform=\"translate(344,714)\" d=\"m0 0 3 3 9 16 11 12 4 5 9 7v2l5 2 11 6 3 7 1 21 4 26 3 16 9 30 10 25 14 29 7 13v2h-7l-14-7-11-8-10-8-17-17-4-5-5-5-9-11-7-10-9-13-6-11-11-23-5-21v-27l4-27 5-22z\" fill=\"#BABABB\"></path><path transform=\"translate(636,714)\" d=\"m0 0h2l4 10 5 25 3 22v24l-3 14-4 12-12 25-7 11-8 12-9 12-15 16-5 6-8 7-13 12-15 10-10 4h-6l2-6 12-23 10-23 7-18 5-17 4-14 6-33 2-30 3-5 15-9 13-12 11-12 9-16z\" fill=\"#BABABB\"></path><path transform=\"translate(258,648)\" d=\"m0 0 4 1 3 9 1 14-3 12-6 15-5 8-8 18-4 16-9 27-5 13-10 25-7 16-8 18-9 20-6 15-5 12-14 35-6 16-4 9h-2v-29l4-40 9-45 7-25 10-33 11-32 8-21 10-19 7-10 10-14 10-13 9-10 6-7z\" fill=\"#BABABB\"></path><path transform=\"translate(721,648)\" d=\"m0 0 5 2 10 10 12 15 10 14 6 8 10 18 6 12 9 25 7 20 3 12 7 21 7 26 4 18 6 31 4 41v25h-3l-9-22-6-16-18-45-7-16-4-9-7-15-4-10-11-27-3-8-6-15-10-31-2-9-10-21-6-12-5-16v-11l3-13z\" fill=\"#BABABB\"></path><path transform=\"translate(793,637)\" d=\"m0 0 6 1 5 5 8 11 12 21 6 12 9 27 5 25 3 18 2 29 5 24 5 20 6 18 4 13 5 13 9 20 6 9-3 1-8-6-9-11-18-24-11-17-8-13-6-11-10-19-7-16-5-12-6-16-7-24-3-17-4-25-1-10v-19l3-14 6-12z\" fill=\"#BABABB\"></path><path transform=\"translate(186,639)\" d=\"m0 0 5 1 6 14 2 13v11l-2 21-6 35-6 20-5 16-4 9-4 10-14 29-12 21-12 19-6 8-10 14-16 20-6 4h-2l2-5 9-17 6-17 7-19 8-27 6-28 2-12 2-30 2-7 2-13 3-12 2-9 3-9 9-22 9-17 5-6 3-6 7-7z\" fill=\"#BABABB\"></path><path transform=\"translate(545,1346)\" d=\"m0 0 4 1 5 10 5 17 8 40 4 39v19l-3 31-1 15-7 51-2 18-5 27-3 8h-1l-7-49-2-21-7-47-2-17-4-14-2-14v-25l4-31 5-29 5-16 4-11z\" fill=\"#BABABB\"></path><path transform=\"translate(434,1346)\" d=\"m0 0h3l6 14 5 16 7 45 1 8 1 27-3 20-4 15-4 31-6 42-1 13-6 43-2 2-4-16-5-29-3-26-5-37-2-26-1-11v-28l2-19 1-12 6-31 4-19 6-17z\" fill=\"#BABABB\"></path><path transform=\"translate(450,670)\" d=\"m0 0h26l6 2 4 8 2 13v23l-1 46-6 7-9-1-15-5-21-5-16-4-7-8-8-16-6-22-1-6v-11l9-7 14-7 13-4z\" fill=\"#BABABB\"></path><path transform=\"translate(474,1)\" d=\"m0 0h34l16 5 14 7 10 9 7 10-1 6-3 5-6 26v26l-4-2-8-7-12-11-8-7-6-8-7-11-7-19-2-9-5 18-6 14-10 14-7 7-14 11-4 5-6 5h-2v-25l-4-18-4-12-2-3v-5l8-11 7-5 5-3 9-6 10-4z\" fill=\"#BABABB\"></path><path transform=\"translate(506,670)\" d=\"m0 0h26l16 3 13 4 18 10 5 4v9l-3 15-6 19-9 16-6 5-26 6-16 4-12 4h-5l-6-6-1-34v-38l3-15 2-4z\" fill=\"#BABABB\"></path><path transform=\"translate(527,1166)\" d=\"m0 0h2l1 83 2 22 3 28 5 30v7l-5 12-7 24-2 8-5 37-2 27-1 6-2-1-7-25-2-8-2-12-4-22-2-16v-79l4-31 7-37 9-33 7-19z\" fill=\"#BABABB\"></path><path transform=\"translate(453,1166)\" d=\"m0 0h2l8 21 10 38 7 40 2 16 1 23v46l-1 21-4 27-4 20-7 25-2 7h-2l-3-38-4-26-1-9-6-21-6-18-2-3 1-9 5-30 2-20 2-17 1-21z\" fill=\"#BABABB\"></path><path transform=\"translate(649,835)\" d=\"m0 0h2l3 27 7 43 1 11 2 24v51l-2 36-1 22-4 34-4 27-2 19-7 37-1 8-5 21h-1l1-37v-93l-2-82v-42l4-41 3-23 2-20z\" fill=\"#BABABB\"></path><path transform=\"translate(332,836)\" d=\"m0 0h1l4 24 3 28 5 45 1 42-2 67v151l-2-4-6-33-1-10-2-5-3-16-2-19-6-44-4-62v-67l4-36 2-11 7-45z\" fill=\"#BABABB\"></path><path transform=\"translate(579,521)\" d=\"m0 0h11l6 4 5 8 8 16 9 17 8 16 10 19 8 19 7 27 1 6v25l-4 12-3 4-3-1-5-14-6-12-12-13-14-15-10-12-6-12-5-19-4-20-4-17-4-27 1-5z\" fill=\"#BABABB\"></path><path transform=\"translate(392,521)\" d=\"m0 0h10l7 6v11l-5 29-7 30-4 17-7 14-12 14-18 18-9 13-6 15-2 6h-3l-5-11-1-4v-27l4-18 5-18 7-15 8-16 8-15 6-11 16-32 6-5z\" fill=\"#BABABB\"></path><path transform=\"translate(456,596)\" d=\"m0 0h23l6 2 3 12v41l-2 9-1 1-36 1-16 2-16 5-14 8-5 2-1-2v-16l3-20 4-15 6-8 9-7 9-5 18-8z\" fill=\"#BABABB\"></path><path transform=\"translate(503,596)\" d=\"m0 0h23l13 3 15 7 13 8 7 6 6 12 4 21 1 23-1 3-5-2-16-9-19-5-11-1-36-1-2-2-1-5-1-17v-13l1-16 3-10z\" fill=\"#BABABB\"></path><path transform=\"translate(490,42)\" d=\"m0 0 3 3 6 10 5 9 9 10 2 6-10 10-5 4-2 3v11l2 22 3 9 10 10 3 5 9 32-1 5-7 10-1 1h-52l-7-12 1-8 6-21 2-8 11-12 3-2 4-32v-10l-5-5-10-9-2-2 1-5 7-8 6-8 7-14zm-18 118 1 4 13 10 6 1 11-7 6-6v-2l-6 2-11 5-9-2-9-5z\" fill=\"#BABABB\"></path><path transform=\"translate(465,512)\" d=\"m0 0 4 2 7 8 9 15 2 3 1 8v31l-4 5-8 2-31 5-15 5-15 7-9 5h-2v-11l2-14 7-28 6-18 7-8 14-8 21-8z\" fill=\"#BABABB\"></path><path transform=\"translate(515,512)\" d=\"m0 0 8 2 13 5 12 5 10 8 6 8 7 24 5 20 2 14v10l-5-1-14-8-16-6-10-3-34-5-5-5v-37l6-12 11-16z\" fill=\"#BABABB\"></path><path transform=\"translate(556,1853)\" d=\"m0 0 3 1-1 8v13l1 16 6 25 1 2v7l-6 8-11 10-12 9-15 14-11 13-8 14-2 5h-1l-1-12v-32l2-17 6-15 3-10 9-21 9-11 5-5 8-7 4-5 5-5z\" fill=\"#BABABB\"></path><path transform=\"translate(424,1853)\" d=\"m0 0 4 2 30 30 6 9 8 19 6 18 3 8 1 6v53l-2-1-8-16-11-13-16-16-12-9-12-11-5-6-1-3 7-29 1-6z\" fill=\"#BABABB\"></path><path transform=\"translate(651,496)\" d=\"m0 0 4 2 3 23 2 30v47l-2 25-3 16-2-1-7-20-8-21-6-15-10-18-6-12-6-14-1-6v-8l3-5 10-8 10-7 15-7z\" fill=\"#BABABB\"></path><path transform=\"translate(329,496)\" d=\"m0 0 8 2 16 8 8 6 10 8 2 4v7l-3 12-9 19-6 10-9 19-5 13-5 14-8 20h-2l-3-23-1-12v-56l2-28 3-22z\" fill=\"#BABABB\"></path><path transform=\"translate(828,873)\" d=\"m0 0 4 2 8 10 8 16 10 25 7 28 1 7v10l-5 26v17l5 13 7 11 4 7-6-1-6-3v-2l-6-2-11-9-9-11-8-13-4-11v-14l6-24v-34l-2-26-3-18z\" fill=\"#BABABB\"></path><path transform=\"translate(152,873)\" d=\"m0 0 2 1-4 27-1 17-1 15v15l3 17 4 14v14l-7 16-10 14-11 11-11 7-8 4h-3l2-5 7-10 6-13 1-5v-13l-5-27v-13l5-22 6-20 7-17 10-18z\" fill=\"#BABABB\"></path><path transform=\"translate(418,42)\" d=\"m0 0 4 2 4 11 4 17 1 8v11l-3 16-6 15-3 6-1 6 13 3 32 5 3 1-1 5-6 10-8 29-1 2-4-2-7-6-14-14-10-13-7-16-3-11-1-14v-21l3-22 5-17z\" fill=\"#BABABB\"></path><path transform=\"translate(562,41)\" d=\"m0 0 5 5 6 16 2 6 3 25v19l-2 18-4 13-7 14-15 16-5 5-5 6-5 3-1 2h-2l-5-16-4-15-6-10-1-5 20-4 24-4 3-2-1-7-6-14-3-9-2-11v-13l4-22 4-13z\" fill=\"#BABABB\"></path><path transform=\"translate(568,1929)\" d=\"m0 0 3 4 4 12 4 16 2 7v17l1 9-4 5-4 3-3 6-9 6-3 3-7 3-4 5-7 1-7-2-1-2-2-14-4-17v-16l3-6 5-6 16-12 8-7 5-6z\" fill=\"#BABABB\"></path><path transform=\"translate(412,1930)\" d=\"m0 0h2l5 10 7 8 18 13 8 8 3 8-1 18-5 20-1 8-2 2-9 1-5-3-4-4-7-3-10-8-3-5-8-8v-23l8-31z\" fill=\"#BABABB\"></path><path transform=\"translate(588,638)\" d=\"m0 0 4 1 10 8 16 16 10 13 5 9 1 13-2 9-9 17-8 12-16 16-17 9-10 1-2-1 2-4 5-5 6-8 7-14 2-6 3-22v-17l-3-27-4-16z\" fill=\"#BABABB\"></path><path transform=\"translate(391,638)\" d=\"m0 0h3l-2 11-3 13-2 20v23l2 17 5 14 8 13 7 8 3 3-2 2-10-1-16-8-5-5-8-7-9-12-9-16-4-8-1-4v-12l2-6 6-10 9-11 8-9 8-7 7-6z\" fill=\"#BABABB\"></path><path transform=\"translate(551,238)\" d=\"m0 0v3l-14 18-12 16-7 10-8 18-5 25 4-12 6-13 8-16 4-7 4-4 10-13 10-12 3-5h2l2 17 1 18-4 8-12 19-12 14-7 8-8 8-11 7-6 2-2-8v-10l2-19 7-23 6-15 9-19 25-12z\" fill=\"#BABABB\"></path><path transform=\"translate(430,238)\" d=\"m0 0 19 9 11 6 5 8 4 10 4 8 9 28 2 14v23l-3 3-10-5-12-11-10-10-3-5-5-5-10-15-8-14 1-21 2-15 5 5 9 11 12 15 6 9 8 16 7 15 3 10-1-9-3-14-5-12-5-10-7-9-21-28-3-3zm47 92 1 3z\" fill=\"#BABABB\"></path><path transform=\"translate(562,289)\" d=\"m0 0 9 3 16 8 28 13 8 3-1 3-13 8-8 4-16 6-11 3-17 3-21 6-12 3-3 1h-8l1-5 16-16 7-8 8-10 4-4 9-14 2-6z\" fill=\"#BABABB\"></path><path transform=\"translate(417,290)\" d=\"m0 0h4l7 13 8 11 12 13 7 8 13 13 1 5h-8l-22-6-23-6-16-3-19-7-12-6-10-7 1-2 8-2 17-8 17-9 10-4z\" fill=\"#BABABB\"></path><path transform=\"translate(846,888)\" d=\"m0 0h2l9 11 7 7 15 9 16 3 12 7 9 7 6 5 6 7 13 13 4 7-14-1h-12l-13 4-10 6-3 1h-8l-6-5-5-10-7-21-5-19-5-11-5-9-6-9z\" fill=\"#BABABB\"></path><path transform=\"translate(134,888)\" d=\"m0 0 2 1-7 11-6 12-6 15-4 16-7 20-4 6-5 5h-9l-17-9-9-2h-11l-14 1 2-4 31-31 11-8 10-4 14-3 11-7 8-7 9-11z\" fill=\"#BABABB\"></path><path transform=\"translate(559,1795)\" d=\"m0 0 3 1 2 8v19l-3 12-5 8-7 8-8 7-13 11-9 9-5 10-6 17-3 10-2 6h-2l-2-8v-38l2-14 3-7 11-11 8-7 17-16 7-7 6-10h2l2-5z\" fill=\"#BABABB\"></path><path transform=\"translate(421,1795)\" d=\"m0 0 5 5 7 10 8 10 8 7 8 8 8 7 9 8 5 6 3 12v50l-3 3-6-16-3-10-6-15-9-10-14-12-12-11-7-9-3-9-1-5v-22l2-6z\" fill=\"#BABABB\"></path><path transform=\"translate(568,161)\" d=\"m0 0h1l-1 10-4 44-3 8-7 6-14 8-15 7-10 3-4-1-1-2v-9l10-16 10-18 6-7 8-7 12-12 8-10z\" fill=\"#BABABB\"></path><path transform=\"translate(413,161)\" d=\"m0 0 7 6 7 9 7 8 5 4 5 5 9 10 8 15 7 10 4 8v8l-2 3-11-2-23-11-11-7-6-7-2-12-4-42z\" fill=\"#BABABB\"></path><path transform=\"translate(904,974)\" d=\"m0 0h5l6 8 3 8-1 4-7 3-6 5-5 12-8 17-5 6-6-1-8-9-5-9-1-4v-19l4-16 2-4h5l3 2 10 1 12-3z\" fill=\"#BABABB\"></path><path transform=\"translate(73,974)\" d=\"m0 0 7 1 12 3 9-1 3-2h5l3 4 3 11v26l-6 12-7 8-7 1-6-10-8-17-3-7-4-5-5-3-5-2 1-8 6-9z\" fill=\"#BABABB\"></path><path transform=\"translate(75,1011)\" d=\"m0 0 4 2 5 12-1 7-8 15-10 18-16 32-5 8-6 4h-7l-3-3-1-8 12-25 12-22 8-14 10-18z\" fill=\"#BABABB\"></path><path transform=\"translate(905,1011)\" d=\"m0 0 3 1 5 8 9 16v2h2l8 16 11 20 6 11 4 10 2 4-1 6-3 4h-7l-7-4-11-21-8-16-8-15-10-18-3-6 3-10z\" fill=\"#BABABB\"></path><path transform=\"translate(467,256)\" d=\"m0 0h8l7 1h17l7-1h9l-7 17-7 19-5 25-2 12-1 2-5-1-4-21-4-18-4-12-4-10-5-11z\" fill=\"#BABABB\"></path><path transform=\"translate(465,210)\" d=\"m0 0h52l1 4-9 13-4 7-3 15-4 2h-15l-4-4-3-14-9-14-3-4z\" fill=\"#BABABB\"></path><path transform=\"translate(917,996)\" d=\"m0 0 5 1 5 8 25 45 6 10 4 11v9l-3 3-5-1-8-11-8-13-7-12-5-8-4-8v-2h-2l-9-17-2-3 1-6z\" fill=\"#BABABB\"></path><path transform=\"translate(60,996)\" d=\"m0 0 6 1 6 5 1 5-8 14-3 6-12 20-12 21-1 2h-2l-2 5-7 8-4-1-2-3v-7l5-14 9-16 6-10 16-30z\" fill=\"#BABABB\"></path><path transform=\"translate(682,523)\" d=\"m0 0 5 1 4 5 5 14 6 20 4 16 7 25 7 24 1 8-4-1-6-7-8-16-7-17-10-31-4-17-2-9v-10z\" fill=\"#BABABB\"></path><path transform=\"translate(295,523)\" d=\"m0 0 5 1 2 5v8l-6 24-5 18-9 26-4 8-4 10-7 10-3 3h-3l1-9 6-21 5-17 6-23 7-25 5-12z\" fill=\"#BABABB\"></path><path transform=\"translate(519,1977)\" d=\"m0 0h2l1 24 3 15v25l-8 5-10 2-8-2v-35l4-10 7-13z\" fill=\"#BABABB\"></path><path transform=\"translate(457,85)\" d=\"m0 0h7l10 7 7 8-2 10-5 20-3 7-5 2h-9l-21-5-9-1-3-3v-7l3-5 7 4 14 7 7 1 10-4 6-5-1-4-9-7-11-3-18 1 6-7 11-11z\" fill=\"#BABABB\"></path><path transform=\"translate(461,1977)\" d=\"m0 0h2l10 13 6 11 3 8 1 23v12l-2 3-6 1-10-2-8-5-1-1v-20l4-22z\" fill=\"#BABABB\"></path><path transform=\"translate(518,85)\" d=\"m0 0h6l11 7 14 14v2l-17-1-10 2-8 6-3 3 1 5 11 6 6 1 10-3 9-5h2v-2l5-2 3 5v7l-3 3-20 3-11 3h-8l-6-3-3-9-4-17-2-10 7-8z\" fill=\"#BABABB\"></path><path transform=\"translate(916,968)\" d=\"m0 0h25l13 5 12 6 13 6 1 3-4 6-5 4-2 1h-10l-15-4-13-2-5-4-9-13-2-4z\" fill=\"#BABABB\"></path><path transform=\"translate(87,1035)\" d=\"m0 0 5 1 6 8-1 5-16 32-8 17-4 7-5 4-9 1-3-3 1-7 5-11 6-13 9-19 5-8 6-11z\" fill=\"#BABABB\"></path><path transform=\"translate(891,1035)\" d=\"m0 0 4 1 4 4 17 33 8 17 6 13-1 5-2 2-9-1-5-3-5-10-11-24-6-10-7-15 1-5z\" fill=\"#BABABB\"></path><path transform=\"translate(40,968)\" d=\"m0 0h26l1 4-6 10-9 10-7 2-14 3-8 2h-10l-6-4-4-5 1-4 30-16z\" fill=\"#BABABB\"></path><path transform=\"translate(490,474)\" d=\"m0 0 4 2 7 8 7 11 1 8-4 8-7 9-6 7-4-2-6-7-9-13-1-6 5-10 7-10z\" fill=\"#BABABB\"></path><path transform=\"translate(666,485)\" d=\"m0 0 5 1 3 15 1 11v34l-3 31-3 25-1 4h-2l-1-5v-29l-1-34-2-23-2-17-1-7z\" fill=\"#BABABB\"></path><path transform=\"translate(311,485)\" d=\"m0 0 6 1 5 4 1 5-2 6-3 34-1 23v41l-2 4-2-5-4-27-2-22v-41l3-20z\" fill=\"#BABABB\"></path><path transform=\"translate(586,119)\" d=\"m0 0 4 2 6 4 3 4 1 5-7 15-10 21-4 4-6-1-1-5 3-11 3-14 7-23z\" fill=\"#BABABB\"></path><path transform=\"translate(159,828)\" d=\"m0 0h2v8l-5 19-10 14-12 13-19 19-6 5-3-1 3-5 7-9 13-18 11-15 10-16 1-2h2l2-5z\" fill=\"#BABABB\"></path><path transform=\"translate(821,828)\" d=\"m0 0h2l6 11 8 11 9 14 12 16 12 17 5 7v2l-4-2-8-7-15-14-7-8-10-12-6-10-4-16-1-8z\" fill=\"#BABABB\"></path><path transform=\"translate(395,120)\" d=\"m0 0 3 3 7 24 3 14 2 10-3 3-6-1-12-23-3-7-4-9 2-7 4-3 6-3z\" fill=\"#BABABB\"></path><path transform=\"translate(859,1043)\" d=\"m0 0 6 1 11 7 5 4 12 23 5 10-1 5-5 1-4-2-8-11-16-28z\" fill=\"#BABABB\"></path><path transform=\"translate(119,1043)\" d=\"m0 0h3l-1 4-12 22-6 10-8 11-5 4-5-1-1-5 8-16 9-17 10-8z\" fill=\"#BABABB\"></path><path transform=\"translate(473,357)\" d=\"m0 0 7 1 5 1h12l6-2h5v5l-6 7-5 10-4 10-2 6-2-4-5-13-6-11-5-6z\" fill=\"#BABABB\"></path><path transform=\"translate(446,110)\" d=\"m0 0 10 1 9 7v4l-3 3-10 2-9-2-7-8 1-4z\" fill=\"#BABABB\"></path><path transform=\"translate(530,110)\" d=\"m0 0 11 1 5 3-1 4-4 5-6 3-7 1-10-3-2-5 8-7z\" fill=\"#BABABB\"></path><path transform=\"translate(636,1195)\" d=\"m0 0\" fill=\"#BABABB\"></path>", 89)
const _hoisted_92 = /*#__PURE__*/_createElementVNode("g", {
  id: "human-body-pin-1",
  class: "pin-group"
}, [
  /*#__PURE__*/_createElementVNode("g", {
    class: "info",
    "data-align": "right",
    "data-value": "1"
  }, [
    /*#__PURE__*/_createElementVNode("line", {
      x1: "770",
      y1: "680",
      x2: "970",
      y2: "580",
      class: "line",
      stroke: "#24292e",
      "stroke-width": "1",
      "stroke-dasharray": "10"
    })
  ]),
  /*#__PURE__*/_createElementVNode("circle", {
    cx: "770",
    cy: "680",
    r: "35",
    class: "pin",
    stroke: "#fff",
    fill: "#006EAB",
    "stroke-width": "5"
  })
], -1 /* HOISTED */)
const _hoisted_93 = /*#__PURE__*/_createElementVNode("g", {
  id: "human-body-pin-2",
  class: "pin-group"
}, [
  /*#__PURE__*/_createElementVNode("g", {
    class: "info",
    "data-align": "left",
    "data-value": "2"
  }, [
    /*#__PURE__*/_createElementVNode("line", {
      x1: "250",
      y1: "380",
      x2: "50",
      y2: "280",
      class: "line",
      stroke: "#24292e",
      "stroke-width": "1",
      "stroke-dasharray": "10"
    })
  ]),
  /*#__PURE__*/_createElementVNode("circle", {
    cx: "250",
    cy: "380",
    r: "35",
    class: "pin",
    stroke: "#fff",
    fill: "#006EAB",
    "stroke-width": "5"
  })
], -1 /* HOISTED */)
const _hoisted_94 = /*#__PURE__*/_createElementVNode("g", {
  id: "human-body-pin-3",
  class: "pin-group"
}, [
  /*#__PURE__*/_createElementVNode("g", {
    class: "info",
    "data-align": "left",
    "data-value": "3"
  }, [
    /*#__PURE__*/_createElementVNode("line", {
      x1: "140",
      y1: "890",
      x2: "-40",
      y2: "790",
      class: "line",
      stroke: "#24292e",
      "stroke-width": "1",
      "stroke-dasharray": "10"
    })
  ]),
  /*#__PURE__*/_createElementVNode("circle", {
    cx: "140",
    cy: "890",
    r: "35",
    class: "pin",
    stroke: "#fff",
    fill: "#006EAB",
    "stroke-width": "5"
  })
], -1 /* HOISTED */)
const _hoisted_95 = /*#__PURE__*/_createElementVNode("g", {
  id: "human-body-pin-4",
  class: "pin-group"
}, [
  /*#__PURE__*/_createElementVNode("g", {
    class: "info",
    "data-align": "right",
    "data-value": "4"
  }, [
    /*#__PURE__*/_createElementVNode("line", {
      x1: "873",
      y1: "973",
      x2: "1073",
      y2: "873",
      class: "line",
      stroke: "#24292e",
      "stroke-width": "1",
      "stroke-dasharray": "10"
    })
  ]),
  /*#__PURE__*/_createElementVNode("circle", {
    cx: "873",
    cy: "973",
    r: "35",
    class: "pin",
    stroke: "#fff",
    fill: "#006EAB",
    "stroke-width": "5"
  })
], -1 /* HOISTED */)
const _hoisted_96 = /*#__PURE__*/_createElementVNode("g", {
  id: "human-body-pin-5",
  class: "pin-group"
}, [
  /*#__PURE__*/_createElementVNode("g", {
    class: "info",
    "data-align": "right",
    "data-value": "5"
  }, [
    /*#__PURE__*/_createElementVNode("line", {
      x1: "491",
      y1: "595",
      x2: "891",
      y2: "395",
      class: "line",
      stroke: "#24292e",
      "stroke-width": "1",
      "stroke-dasharray": "10"
    })
  ]),
  /*#__PURE__*/_createElementVNode("circle", {
    cx: "491",
    cy: "595",
    r: "35",
    class: "pin",
    stroke: "#fff",
    fill: "#006EAB",
    "stroke-width": "5"
  })
], -1 /* HOISTED */)
const _hoisted_97 = /*#__PURE__*/_createElementVNode("g", {
  id: "human-body-pin-6",
  class: "pin-group"
}, [
  /*#__PURE__*/_createElementVNode("g", {
    class: "info",
    "data-align": "left",
    "data-value": "6"
  }, [
    /*#__PURE__*/_createElementVNode("line", {
      x1: "395",
      y1: "1140",
      x2: "195",
      y2: "1240",
      class: "line",
      stroke: "#24292e",
      "stroke-width": "1",
      "stroke-dasharray": "10"
    })
  ]),
  /*#__PURE__*/_createElementVNode("circle", {
    cx: "395",
    cy: "1140",
    r: "35",
    class: "pin",
    stroke: "#fff",
    fill: "#006EAB",
    "stroke-width": "5"
  })
], -1 /* HOISTED */)
const _hoisted_98 = /*#__PURE__*/_createElementVNode("g", {
  id: "human-body-pin-7",
  class: "pin-group"
}, [
  /*#__PURE__*/_createElementVNode("g", {
    class: "info",
    "data-align": "left",
    "data-value": "7"
  }, [
    /*#__PURE__*/_createElementVNode("line", {
      x1: "425",
      y1: "1620",
      x2: "225",
      y2: "1520",
      class: "line",
      stroke: "#24292e",
      "stroke-width": "1",
      "stroke-dasharray": "10"
    })
  ]),
  /*#__PURE__*/_createElementVNode("circle", {
    cx: "425",
    cy: "1620",
    r: "35",
    class: "pin",
    stroke: "#fff",
    fill: "#006EAB",
    "stroke-width": "5"
  })
], -1 /* HOISTED */)
const _hoisted_99 = /*#__PURE__*/_createElementVNode("g", {
  id: "human-body-pin-8",
  class: "pin-group"
}, [
  /*#__PURE__*/_createElementVNode("g", {
    class: "info",
    "data-align": "right",
    "data-value": "8"
  }, [
    /*#__PURE__*/_createElementVNode("line", {
      x1: "555",
      y1: "1420",
      x2: "755",
      y2: "1320",
      class: "line",
      stroke: "#24292e",
      "stroke-width": "1",
      "stroke-dasharray": "10"
    })
  ]),
  /*#__PURE__*/_createElementVNode("circle", {
    cx: "555",
    cy: "1420",
    r: "35",
    class: "pin",
    stroke: "#fff",
    fill: "#006EAB",
    "stroke-width": "5"
  })
], -1 /* HOISTED */)
const _hoisted_100 = /*#__PURE__*/_createElementVNode("g", {
  id: "human-body-pin-9",
  class: "pin-group"
}, [
  /*#__PURE__*/_createElementVNode("g", {
    class: "info",
    "data-align": "right",
    "data-value": "9"
  }, [
    /*#__PURE__*/_createElementVNode("line", {
      x1: "535",
      y1: "1910",
      x2: "735",
      y2: "1810",
      class: "line",
      stroke: "#24292e",
      "stroke-width": "1",
      "stroke-dasharray": "10"
    })
  ]),
  /*#__PURE__*/_createElementVNode("circle", {
    cx: "535",
    cy: "1910",
    r: "35",
    class: "pin",
    stroke: "#fff",
    fill: "#006EAB",
    "stroke-width": "5"
  })
], -1 /* HOISTED */)
const _hoisted_101 = /*#__PURE__*/_createElementVNode("g", {
  id: "human-body-pin-10",
  class: "pin-group"
}, [
  /*#__PURE__*/_createElementVNode("g", {
    class: "info",
    "data-align": "left",
    "data-value": "10"
  }, [
    /*#__PURE__*/_createElementVNode("line", {
      x1: "435",
      y1: "2010",
      x2: "235",
      y2: "1910",
      class: "line",
      stroke: "#24292e",
      "stroke-width": "1",
      "stroke-dasharray": "10"
    })
  ]),
  /*#__PURE__*/_createElementVNode("circle", {
    cx: "435",
    cy: "2010",
    r: "35",
    class: "pin",
    stroke: "#fff",
    fill: "#006EAB",
    "stroke-width": "5"
  })
], -1 /* HOISTED */)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(), _createElementBlock("svg", {
      version: "1.1",
      viewBox: "0 0 981 2048",
      width: "100%",
      xmlns: "http://www.w3.org/2000/svg",
      id: `human-body-${_ctx.step_id}-${_ctx.role}`,
      class: "human-body-map"
    }, [
      _hoisted_3,
      _createCommentVNode(" PINS "),
      _createCommentVNode(" gomito "),
      _hoisted_92,
      _createCommentVNode(" spalla "),
      _hoisted_93,
      _createCommentVNode(" polso "),
      _hoisted_94,
      _createCommentVNode(" mano "),
      _hoisted_95,
      _createCommentVNode(" colonna "),
      _hoisted_96,
      _createCommentVNode(" coscia "),
      _hoisted_97,
      _createCommentVNode(" gamba "),
      _hoisted_98,
      _createCommentVNode(" ginocchio "),
      _hoisted_99,
      _createCommentVNode(" piede "),
      _hoisted_100,
      _createCommentVNode(" dita-piede "),
      _hoisted_101
    ], 8 /* PROPS */, _hoisted_2))
  ]))
}